import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box, Grid, Paper } from '@material-ui/core';
import { clubs } from './clubsGenerator';
import ProfileTitle from '../../layout/mobile/profile/ProfileTitle';
import useStyles from './styles';
import ClubsIcon from '../../common/icons/clubsIcon';

const Clubs = ({ ...props }) => {
  const { mobile } = props;
  const classes = useStyles();
  const profile = useSelector((state) => state.profileReducer.profile);

  return (
    <Box className={classes.container}>
      <ProfileTitle
        mobile={mobile}
        subtitle={
          'Aquí podrás encontrar próximamente al club que perteneces y/o inscribirte a los que quieras.'
        }
        title={<strong>Clubes Ripley</strong>}
        icon={<ClubsIcon size="30px" color="#6A148E" />}
      />
      {profile && (
        <div>
          <Grid container className={classes.grid}>
            <Grid item xs={12}>
              <Grid container justify="center" spacing={1}>
                {clubs.map((club, key) => (
                  <Grid
                    item
                    xs={12}
                    md={6}
                    lg={4}
                    key={key}
                    onClick={() => {
                      window.open(club.link, '_blank');
                    }}
                    data-cy={club.name}
                  >
                    <Paper className={classes.paper}>
                      <img src={club.image} className={classes.imageCard} />
                      <div className={classes.containerLogo}>
                        <img src={club.rImage} className={classes.rLogoCard} />
                      </div>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </Box>
  );
};

Clubs.propTypes = {
  mobile: PropTypes.bool,
};

export default Clubs;
